import { render, staticRenderFns } from "./EditExpenseLabelModal.vue?vue&type=template&id=49f67053&scoped=true&class=fill-height&"
import script from "./EditExpenseLabelModal.vue?vue&type=script&lang=ts&"
export * from "./EditExpenseLabelModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f67053",
  null
  
)

export default component.exports